import { createAction } from "redux-actions";
import { makeActionTypes } from "../../utils";

export const types = makeActionTypes("PLATFORM_REPORTING", ["RESET"]);

export const newApiTypes = {
  listDashboards: "list-platform-reporting-dashboards",
  getEmbedUrl: "get-platform-reporting-embed-url",
  dashboards: "platform-reporting-dashboards",
  rejectDashboards: "error-listing-platform-reporting-dashboards",
  embedUrl: "platform-reporting-embed-url",
  rejectEmbedUrl: "error-getting-platform-reporting-embed-url",
};

export const actions = {
  listDashboards: createAction(newApiTypes.listDashboards),
  getEmbedUrl: createAction(newApiTypes.getEmbedUrl),
  dashboards: createAction(newApiTypes.dashboards),
  rejectDashboards: createAction(newApiTypes.rejectDashboards),
  embedUrl: createAction(newApiTypes.embedUrl),
  rejectEmbedUrl: createAction(newApiTypes.rejectEmbedUrl),
  reset: createAction(types.RESET),
};

export default actions;
